import React from "react";
import PropTypes from "prop-types";
import styles from "./AccountIssueBanner.module.css";
import WarningIcon from "assets/warning_icon-white.png";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

export function AccountIssueBanner({ onClick }) {
  const {t} = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <img src={WarningIcon} alt={"Warning"} className={styles.icon} />
        </div>
        <div className={styles.text}>
          <span className={styles.warningText}>{t("Warning")}</span>
          <span className={styles.accountText}>
            {t("There are alerts on your account")}
          </span>
        </div>
      </div>
      <div>
        <Button buttonText={t("View")} onClick={onClick} className={""} />
      </div>
    </div>
  );
}

AccountIssueBanner.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};
